<script>
    import {createEventDispatcher, onMount} from 'svelte';
    import {session} from './Utilities/Session.svelte';
    import AssessmentNav from './Components/AssessmentNav.svelte';
    import {sortBy} from 'lodash-es';
    import Collapse from './Components/Collapse.svelte';

    import QuestionTypes from './lib/QuestionTypes';
    import {generateCSV} from './lib/csv';
    import { showContextMenu } from './Components/ContextMenu.svelte';
    import { addFormModal } from './Forms/ModalFormManager.svelte';
    import {userMap} from './Utilities/Session.svelte';

    import Fa from 'svelte-fa';
    import {faComment, faMagnifyingGlass} from "@fortawesome/free-solid-svg-icons";

    import {faSquare, faSquareCheck} from "@fortawesome/free-regular-svg-icons";

    const dispatch = createEventDispatcher();

    export let assessment;
    export let assessment_model;
    export let questions;
    export let tagFilter = [];
    export let questionTagFilter = [];
    export let topicTagFilter = [];
    export let commentTagFilter = [];
    export let controlScroll = "";

    export let statusType = "assessor";

    export let levelFilter;
    export let answerFilter = 0;
    export let searchComments = false;

    export let hiddenControls = {};

    export let socket;

    let unCollapsedControls = {}
    let assessorControls = {};

    export let searchText = "";
    let debounceTimer;
    let showQuestion = false;


    // counts
    let total_controls = 0;
    let answered_controls = 0;
    let category_counts = {};

    let dock_filter = false;

    function handleContextMenu(evt, category) {
        showContextMenu(evt.clientX, evt.clientY, [
            {
                name: "Mark N/A",
                action: () => markNA(category)
            }
        ])
    }

    function markNA(category) {
        for (let subcategory of category.subcategories) {
            for (let control of subcategory.controls) {
                if (control.question_type == "free_text") {
                    continue
                }

                if (!getStatus($session.user.email, control.id, '', 'practice_status', assessment).value) {
                    setStatus($session.user.email, control.id, '', 'practice_status', "-1");
                }


                if (assessment.domains.mapping[control.id]?.length) {
                    for (let domain of assessment.domains.mapping[control.id]) {
                        if (!getStatus($session.user.email, control.id, domain, 'practice_status', assessment).value) {
                            setStatus($session.user.email, control.id, domain, 'practice_status', "-1");
                        }
                    }
                }
            }
        }
    }

    function debounce(func, ms) {
        if (!ms) ms = 50;

        if (debounceTimer) clearTimeout(debounceTimer);

        debounceTimer = setTimeout(func, ms);
    }

    function getControlAssessors(control_id, assessorControls) {
        let assessors = [];
        Object.entries(assessorControls).forEach((item) => {
            let [assessor, cid] = item

            if (cid == control_id) {
                assessors.push(assessor);
            }
        });
        return assessors;
    }


    async function filterControls(levelFilter, searchText) {

        debounce(async () => {
            if (!levelFilter) return;

            let lowerSearch = searchText.toLowerCase()

            questions.forEach((category) => {
                let hide_category = true;
                category.subcategories.forEach((subcategory) => {
                    let hide_subcategory = true;
                    subcategory.controls.forEach((control) => {
                        let hide_control = true;

                        if (
                            control.level <= levelFilter
                            &&
                            (
                                searchText == "" ||
                                control.text.toLowerCase().includes(lowerSearch) ||
                                control.control_number.toLowerCase().includes(lowerSearch) ||
                                (control.name || "").toLowerCase().includes(lowerSearch) ||
                                (searchComments && (assessment.control_notes[control.id] || []).some((note) => note.note.toLowerCase().includes(lowerSearch)))
                            )
                            &&
                            (
                                answerFilter == 0 ||
                                (answerFilter == 1 && getStatus($session.user.email, control.id, '', 'practice_status', assessment).value) ||
                                (answerFilter == -1 && !getStatus($session.user.email, control.id, '', 'practice_status', assessment).value)
                            )
                        ) {
                            if (tagFilter.length || questionTagFilter.length || topicTagFilter.length || commentTagFilter.length) {
                                for (let tag of tagFilter) {
                                    if ((assessment.domains.mapping[control.id] || []).indexOf(tag) !== -1){
                                        hide_control = false;
                                        hide_subcategory = false;
                                        hide_category = false;
                                        break
                                    }
                                }

                                for (let tag_id of questionTagFilter) {
                                    if (assessment_model.getTag(control.id, tag_id).value) {
                                        hide_control = false;
                                        hide_subcategory = false;
                                        hide_category = false;
                                        break;
                                    }
                                }

                                for (let tag of topicTagFilter) {
                                    if (control.topic_tags.includes(tag)) {
                                        hide_control = false;
                                        hide_subcategory = false;
                                        hide_category = false;
                                        break;
                                    }
                                }

                                for (let tag_id of commentTagFilter) {
                                    if ((assessment.control_notes[control.id] || []).some(note => note.tags && note.tags.some(tag => tag.id == tag_id))) {
                                        hide_control = false;
                                        hide_subcategory = false;
                                        hide_category = false;
                                        break;
                                    }
                                }
                            } else {
                                hide_control = false;
                                hide_subcategory = false;
                                hide_category = false;
                            }
                        }

                        hiddenControls[control.id] = hide_control;
                    });
                    hiddenControls[subcategory.id] = hide_subcategory;
                });
                hiddenControls[category.id] = hide_category;
            });

            updateCounts();

            return;
        });
    }

    function toggleQuestionTagFilter(tag_id) {
        if (questionTagFilter.indexOf(tag_id) == -1) {
            questionTagFilter = [...questionTagFilter, tag_id]
        } else {
            questionTagFilter = questionTagFilter.filter(t => t != tag_id);
        }
    }

    function toggleDomainFilter(domain) {
        if (tagFilter.indexOf(domain) == -1) {
            tagFilter = [...tagFilter, domain]
        } else {
            tagFilter = tagFilter.filter((d) => d != domain)
        }
    }

    function toggleTopicTagFilter(tag) {
        if (topicTagFilter.indexOf(tag) == -1) {
            topicTagFilter = [...topicTagFilter, tag];
        } else {
            topicTagFilter = topicTagFilter.filter(t => t != tag);
        }
    }

    function toggleCommentTagFilter(tag) {
        if (commentTagFilter.indexOf(tag.tag_id) == -1) {
            commentTagFilter = [...commentTagFilter, tag.tag_id];
        } else {
            commentTagFilter = commentTagFilter.filter(t => t != tag.tag_id);
        }

    }

    function getStatus(assessor, control_id, domain, type) {
        if (!assessment) return;

        if (statusType == "assessor") {
            return assessment_model.getAnswer(assessor, control_id, domain, type);
        } else {
            return assessment_model.getResult(control_id, domain, type);
        }
    }

    function setStatus(assessor, control_id, domain, type, answer) {
        if (!assessment) return;

        if (statusType == "assessor") {
            return assessment_model.setAnswer(assessor, control_id, domain, type, answer);
        } else {
            return assessment_model.setResult(control_id, domain, type, answer);
        }
    }


    async function updateCounts() {
        total_controls = 0;
        answered_controls = 0;

        if (!assessment) return;

        for (let category of questions) {
             category_counts[category.id] = {
                total_controls: 0,
                answered_controls: 0
            }
            for (let subcategory of category.subcategories) {
                for (let control of subcategory.controls) {
                    if (control.level <= levelFilter) {
                        total_controls++;
                        total_controls += (assessment.domains.mapping[control.id] || []).length;

                        if (!hiddenControls[control.id]) {
                            category_counts[category.id].total_controls++;
                            category_counts[category.id].total_controls += (assessment.domains.mapping[control.id] || []).length;
                        }

                        if (getStatus($session.user.email, control.id, '', 'practice_status', assessment).value) {
                            answered_controls++;

                            if (!hiddenControls[control.id]) {
                                category_counts[category.id].answered_controls++;
                            }
                        }

                       (assessment.domains.mapping[control.id] || []).forEach((domain) => {
                            if (getStatus($session.user.email, control.id, domain, 'practice_status', assessment).value) {
                                answered_controls++;

                                if (!hiddenControls[control.id]) {
                                    category_counts[category.id].answered_controls++;
                                }
                            }
                       })
                    }
                }
            }
        }
    }

    function collapseAll() {
        document.querySelectorAll(".menu .collapse").forEach(checkbox => {
            unCollapsedControls[checkbox.id] = false;
        })
    }

    function expandAll() {
        document.querySelectorAll(".menu .collapse").forEach(checkbox => {
            unCollapsedControls[checkbox.id] = true;
        })
    }

    async function exportVisible() {
        let question_tags = sortBy([...(assessment.assessment_type_data.question_tags || []), ...(assessment.question_tags.tags)], "name");
        let comment_tags = sortBy([...(assessment.assessment_type_data.comment_tags || []), ...(assessment.comment_tags.tags)], "name");

        let exportOptions = await addFormModal({
            fields: [
                {
                    name: "include_comments",
                    label: "Include Comments",
                    type: "checkbox"
                },
                {
                    name: "comment_tags",
                    label: "Comment Tags",
                    type: "select",
                    multiple: "true",
                    preq: {
                        field: "include_comments",
                        value: true
                    },
                    choices: {
                        static: comment_tags.map((t) => {return {label: t.name, value: t.tag_id || t.id}})
                    }
                },
                {
                    name: "include_question_tags",
                    label: "Include Question Tags",
                    type: "checkbox"
                },
                {
                    name: "question_tags",
                    label: "Question Tags",
                    type: "select",
                    multiple: "true",
                    preq: {
                        field: "include_question_tags",
                        value: true
                    },
                    choices: {
                        static: question_tags.map((t) => {return {label: t.name, value: {name: t.name, id:t.tag_id || t.id}}})
                    }
                }
            ]
        });

        if (!exportOptions.include_question_tags) {
            exportOptions.question_tags = [];
        }

        // generate headers
        let headers = ['Category ID', 'Category', 'Subcategory ID', 'Subcategory', 'Control ID', 'Control Title', 'Control Text', 'Answer'];

        if (exportOptions.include_comments) {
            headers.push("Comments");
        }

        for (let tag of exportOptions.question_tags) {
            headers.push(tag.name);
        }

        let csv_data = [];
        for (let category of questions) {
            if (hiddenControls[category.id]) continue
            for (let subcategory of category.subcategories) {
                if (hiddenControls[subcategory.id]) continue
                for (let control of subcategory.controls) {
                    if (hiddenControls[control.id]) continue;

                    let control_status = getStatus($session.user.email, control.id, '', 'practice_status', assessment).value;

                    let answer = "";
                    if (control_status) {
                        if (control.question_type == "free_text") {
                            answer = control_status;
                        } else {
                            answer = QuestionTypes[control.question_type || "implementation_status"].buttons[control_status].label
                        }
                    }

                    let control_data = [
                        category.control_number,
                        category.name,
                        subcategory.control_number,
                        subcategory.name,
                        control.control_number,
                        control.name,
                        control.text,
                        answer
                    ];

                    let control_notes = [];
                    if (exportOptions.include_comments) {
                        for (let note of assessment.control_notes[control.id] || []) {
                            if (exportOptions.comment_tags.length) {
                                for (let tag of note.tags) {
                                    if (exportOptions.comment_tags.includes(tag.id || tag.tag_id)) {
                                        control_notes.push(note.note);
                                        break
                                    }
                                }
                            } else {
                                control_notes.push(note.note);
                            }
                        }

                        control_data.push(control_notes.join('\n'));
                    }

                    for (let tag of exportOptions.question_tags) {
                        control_data.push(assessment_model.getTag(control.id, tag.id).value ? "X": "");
                    }

                    csv_data.push(control_data);
                }
            }
        }

        let csv_string = generateCSV(headers, csv_data);
        var blob = new Blob([new Uint8Array([0xEF, 0xBB, 0xBF]), csv_string], { type: 'text/csv;charset=utf-8;' });
        let url = URL.createObjectURL(blob);
        let link = document.createElement("a");
        link.href = url;
        link.download = `${assessment.details.name}_export.csv`;
        link.target = "_new";

        link.click();

        URL.revokeObjectURL(url);
    }

    $: filterControls(levelFilter, searchText, tagFilter, questionTagFilter, topicTagFilter, answerFilter, searchComments, commentTagFilter);
    $: updateCounts(assessment)

    onMount(() => {
        if (socket) {
            socket.on("broadcast", (msg) => {
                if (msg.type == "assessorControl") {
                    assessorControls[msg.email] = msg.control_id
                } else if (msg.type == "assessorLeave") {
                    assessorControls[msg.email] = undefined
                }
            })
        }
    })

    function dragStart(evt, domain) {
        evt.dataTransfer.setData("Text", domain);
        evt.dataTransfer.setDragImage(evt.target, 0, 0);

        return true;
    }
</script>
<div class:sidebar={dock_filter}>
<div class="filtering">
    <AssessmentNav assessment_id={assessment.details._id} />

    <h1 class="title is-1">
        {assessment.details.name}
        <slot name="buttons"></slot>
    </h1>
    <div class="buttons has-addons is-centered">
        <button class="button" class:is-link={levelFilter == 1} on:click={() => levelFilter = 1}>Level 1</button>
        <button class="button" class:is-link={levelFilter == 2} on:click={() => levelFilter = 2}>Level 2</button>
        <button class="button" class:is-link={levelFilter == 3} on:click={() => levelFilter = 3}>Level 3</button>
        <button class="button" class:is-link={levelFilter == 4} on:click={() => levelFilter = 4}>Level 4</button>
        <button class="button" class:is-link={levelFilter == 5} on:click={() => levelFilter = 5}>Level 5</button>
    </div>
    <div class="field">
        <p class="control has-icons-left has-icons-right">
            <input class="input is-rounded" type="text" placeholder="Search" bind:value={searchText}>
            <span class="icons">
                <span class="icon is-right">
                    <button class="delete" aria-label="delete" on:click={() => searchText = ""}></button>
                </span>
                <span class="icon is-small is-left magnifying-glass">
                    <Fa icon={faMagnifyingGlass} />
                </span>
            </span>
        </p>
        <label class="checkbox has-text-right">
            <input type="checkbox" bind:checked={searchComments}>
            Include Comments
        </label>
    </div>
    <div class="status columns">
        <div class="column is-narrow">{answered_controls}/{total_controls}</div>
        <div class="column progressbar">
            <progress class="progress is-primary is-small" value="{answered_controls}" max="{total_controls}">{Math.floor(answered_controls/total_controls*100)}%</progress>
        </div>
        <div class="column is-narrow">{Math.floor(answered_controls/total_controls*100)}%</div>
    </div>
    {#if assessment.scope_notes.length}
    <div>
        <Collapse collapsed={false}>
            <h7 slot="title" class="title is-7">Scope Notes</h7>
            <div class="tags">
                {#each assessment.scope_notes as note}
                    <span class="tag is-{note.color_class} is-medium">{note.note}</span>
                {/each}
            </div>
        </Collapse>
    </div>
    {/if}
    <div>
        <h7 class="title is-7">Answer Status</h7>
        <div class="tags">
            <span class="tag pointer" class:is-info={answerFilter === 1} on:click={() => answerFilter = answerFilter == 1 ? 0 : 1}>Answered</span>
            <span class="tag pointer" class:is-info={answerFilter === -1} on:click={() => answerFilter = answerFilter == -1 ? 0 : -1}>Un-Answered</span>
        </div>
    </div>
    {#if assessment.domains.names.length}
    <div>
        <Collapse>
            <h7 slot="title" class="title is-7">Scope Domains</h7>
            <div class="tags">
                {#each assessment.domains.names as domain}
                    <span class="tag pointer" class:is-info={tagFilter.indexOf(domain) !== -1} on:click={() => toggleDomainFilter(domain)} draggable="true" on:dragstart={(evt) => dragStart(evt, domain)}>
                        {domain}
                    </span>
                {/each}
            </div>
        </Collapse>
    </div>
    {/if}
    <div>
        <Collapse>
            <h7 class="title is-7" slot="title">Question Tags</h7>
            <div class="tags">
                {#if assessment.assessment_type_data.question_tags}
                    {#each assessment.assessment_type_data.question_tags as tag}
                        {#if tag.color_class}
                            <span class="tag pointer is-{tag.color_class}" class:is-light={questionTagFilter.indexOf(tag.tag_id) == -1} on:click={toggleQuestionTagFilter(tag.tag_id)}>{tag.name}</span>
                        {:else}
                            <span class="tag pointer" class:is-info={questionTagFilter.indexOf(tag.tag_id) !== -1} on:click={toggleQuestionTagFilter(tag.tag_id)}>{tag.name}</span>
                        {/if}
                    {/each}
                {/if}
                {#each assessment.question_tags.tags as tag}
                    <span class="tag pointer is-{tag.color_class}" class:is-light={questionTagFilter.indexOf(tag.id) == -1} on:click={toggleQuestionTagFilter(tag.id)}>{tag.name}</span>
                {/each}
            </div>
        </Collapse>
    </div>
    {#if assessment.assessment_type_data.topic_tags}
    <div>
        <Collapse>
            <h7 slot="title" class="title is-7">Topic Tags</h7>
            <div class="tags">
                {#each sortBy(assessment.assessment_type_data.topic_tags) as tag}
                    <span class="tag pointer" class:is-info={topicTagFilter.indexOf(tag) !== -1} on:click={toggleTopicTagFilter(tag)}>{tag}</span>
                {/each}
            </div>
        </Collapse>
    </div>
    {/if}

    {#if assessment.assessment_type_data.comment_tags || assessment.comment_tags}
        <div>
            <Collapse>
                <h7 slot="title" class="title is-7">Comment Tags</h7>
                <div class="tags">
                    {#each sortBy([...(assessment.assessment_type_data.comment_tags || []), ...assessment.comment_tags.tags]) as tag}
                        <span class="tag pointer is-{tag.color_class}" class:is-light={commentTagFilter.indexOf(tag.tag_id) == -1} on:click={toggleCommentTagFilter(tag)}>{tag.name}</span>
                    {/each}
                </div>
            </Collapse>
        </div>
    {/if}

    <div>
        <Collapse>
            <h7 slot="title" class="title is-7">Export</h7>
            <span on:click={exportVisible} class="link is-size-7">Export Visible</span>
        </Collapse>
    </div>

    <div>
        <h7 class="title is-7">Assessors</h7>
        <div class="tags">
            {#each Object.entries(assessorControls) as [assessor, control_id]}
                <span class="tag pointer" on:click={() => dispatch("controlClick", {control: {id: control_id}})}>{$userMap[assessor] || assessor}</span>
            {/each}
        </div>
    </div>
    <slot name="filter"></slot>
    <hr>
    <div style="margin-bottom: 5px;">
        <label class="checkbox has-text-right">
            <input type="checkbox" bind:checked={showQuestion}>
            Show Entire Questions
        </label>
    </div>
    <div class="is-pulled-left">
        <span class="pointer is-size-6 collapse-all" on:click={collapseAll}>
            [-] Collapse All
        </span>
        <br>
        <span class="pointer is-size-6 collapse-all" on:click={expandAll}>
            [+] Expand All
        </span>
    </div>
    <label class="is-pulled-right is-size-5">
        Dock Filter Controls
        <input type="checkbox" bind:checked={dock_filter}>
    </label>
    <br class="clear">
    <hr>
</div>
<aside class="menu">
    <ul class="menu-list">
    {#each questions as category (category.id)}
        <li class:is-hidden={hiddenControls[category.id]}>
            <input type="checkbox" class="collapse" id="{category.id}" bind:checked={unCollapsedControls[category.id]}>
            <label class="link" for={category.id} on:contextmenu|preventDefault={(evt) => handleContextMenu(evt, category)}>
                {category.name} ({category.control_number}) - ({category_counts[category.id].answered_controls}/{category_counts[category.id].total_controls})
            </label>
            {#if unCollapsedControls[category.id]}
            <ul>
            {#each category.subcategories as subcategory (subcategory.id)}
                <li class:is-hidden={hiddenControls[subcategory.id]}>
                    <b>{subcategory.control_number}</b> {subcategory.name}
                    <ul>
                        {#each subcategory.controls as control (control.id)}
                            <li class:is-hidden={hiddenControls[control.id]}>
                                <span
                                    class="menu-item link"
                                    class:is-active={controlScroll == control.id}
                                    on:click={() => dispatch("controlClick", {category: category, subcategory: subcategory, control: control})}
                                    data-control-id={control.id}
                                >
                                    <!-- Control Status -->
                                    <span class="status" >
                                        {#if getStatus($session.user.email, control.id, '', 'practice_status', assessment).value}
                                            <span class="has-text-success"><Fa icon={faSquareCheck} /></span>
                                        {:else}
                                            <span class="has-text-danger"><Fa icon={faSquare} /></span>
                                        {/if}
                                    </span>

                                    <b>{control.control_number}</b>
                                    {#if showQuestion}
                                        {control.text}
                                    {:else}
                                        {control.name || control.text}
                                    {/if}

                                    {#each getControlAssessors(control.id, assessorControls) as assessor}
                                        <div class="tag is-small is-primary">{$userMap[assessor] || assessor}</div>
                                    {/each}

                                    <div class="columns badge-info">
                                        <div class="column">
                                            <!-- Scope Domains -->
                                            {#if assessment.domains.mapping[control.id] && assessment.domains.mapping[control.id].length}
                                            <div class="field is-grouped is-grouped-multiline">
                                                {#each assessment.domains.mapping[control.id] as domain}
                                                    <div class="control">
                                                        <div class="tags has-addons">
                                                            <span class="tag"  class:is-info={tagFilter.indexOf(domain) !== -1}>
                                                                {domain}
                                                            </span>
                                                            {#if getStatus($session.user.email, control.id, domain, 'practice_status', assessment).value}
                                                                <span class="tag is-success is-light"> &#128505;</span>
                                                            {:else}
                                                                <span class="tag is-danger is-light"> &#9744;</span>
                                                            {/if}
                                                        </div>
                                                    </div>
                                                {/each}
                                            </div>
                                            {/if}

                                            <!-- Question Tags -->
                                            <span class="tags">
                                            {#if assessment.assessment_type_data.question_tags}
                                                {#each assessment.assessment_type_data.question_tags as tag}
                                                    {#if assessment_model.getTag(control.id, tag.tag_id).value}
                                                        <span class="tag is-{tag.color_class}">{tag.name}</span>
                                                    {/if}
                                                {/each}
                                            {/if}
                                            {#each assessment.question_tags.tags as tag (tag.id)}
                                                {#if assessment_model.getTag(control.id, tag.id).value}
                                                    <span class="tag is-{tag.color_class}">{tag.name}</span>
                                                {/if}
                                            {/each}
                                            </span>
                                        </div>
                                        <div  class="column has-text-right is-narrow">
                                            <span>
                                                <!-- Comments -->
                                                {#if (assessment.control_notes[control.id] || []).length}
                                                    <span class="badge">
                                                        <Fa icon={faComment} />
                                                        <span>{assessment.control_notes[control.id].length}</span>
                                                    </span>
                                                {/if}

                                                <!-- Evidence -->
                                                {#if (assessment.evidence[control.id] || []).length}
                                                <span class="badge">
                                                    &#128193;
                                                    <span>{assessment.evidence[control.id].length}</span>
                                                </span>
                                                {/if}
                                            </span>
                                        </div>
                                    </div>
                                </span>
                            </li>
                        {/each}
                    </ul>
                </li>
            {/each}
            </ul>
            {/if}
        </li>
    {/each}
    {#if assessment.orphaned_controls.controls.length}
    <hr>
        <li>
            <input type="checkbox" class="collapse" id="orphaned" bind:checked={unCollapsedControls['orphaned']}>
            <label class="link" for="orphaned">
                Orphaned Controls ({assessment.orphaned_controls.controls.length})
            </label>
            <ul class:is-hidden={!unCollapsedControls['orphaned']}>
            {#each assessment.orphaned_controls.controls as control}
                <li>
                    <span class="menu-item link" on:click={() => dispatch("controlClick", {category: "orphan", subcategory: "orphan", control: control.control})}>
                        <b>{control.control.control_number}</b>
                        {control.control.name}
                    </span>
                </li>
            {/each}
            </ul>
        </li>
    {/if}
    </ul>
</aside>
</div>

<style>
    .menu {
        padding-bottom: 5em;
    }

    ul.menu-list, .collapse-all {
        line-height: 1.5em;
        font-family: Consolas, monaco, monospace;
    }

    .menu-list li ul {
        padding: .25em;
        margin: .25em;
    }

    .filtering {
        height: min-content;
    }

    .badge-info {
        margin-top: 5px;
        margin-bottom: 0;
        min-height: 2em;
    }

    .columns.badge-info .column {
        padding: 0;
        overflow: visible;
    }

    .sidebar {
        height: 100%;
        display: grid;
        grid-template-rows: min-content auto;
    }

    .sidebar aside.menu {
        overflow: auto;
    }

    label.link {
        padding: 0;
    }

    .field.is-grouped {
        padding: .5em;
    }

    :global(.panel-tabs) {
        justify-content: space-around;
    }
</style>